import { render } from "./ViewTourPartInvitation.vue?vue&type=template&id=393ae733&scoped=true"
import script from "./ViewTourPartInvitation.vue?vue&type=script&lang=ts"
export * from "./ViewTourPartInvitation.vue?vue&type=script&lang=ts"

import "./ViewTourPartInvitation.vue?vue&type=style&index=0&id=393ae733&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-393ae733"

export default script